import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import './Tabs.css' // Import your CSS file
import LineChart from './LineChart'
import axios from 'axios'
import Chart from 'chart.js'
import { Modal, Button } from 'react-bootstrap'
import { MathJax, MathJaxContext } from 'better-react-mathjax'
import ScoreCards from './ScoreCards'
import ScoreTable from './ScoreTable'
import AccuracyChart from './AccuracyChart'
import ScoreTabs from './ScoreTabs'
import EnglishStatsCards from './EnglishStatsCards'
import StrengthsWeaknesses from './StrengthsWeaknesses'

const ActScores = () => {
  useEffect(() => {
    getReport()
    gettests(id)
    getsweekness()
    getsweekness2()
    getsweekness3()
    getsweekness4()
  }, [])
  const rolename = localStorage.getItem('role')
  const [data, setData] = useState([])
  const [results, setResults] = useState([])
  const [results2, setResults2] = useState([])
  const [results3, setResults3] = useState([])
  const [results4, setResults4] = useState([])
  const [activeTab, setActiveTab] = useState('score-view')
  const [innerActiveTab, setInnerActiveTab] = useState(10) // For inner tabs
  const [ractiveTab, rsetActiveTab] = useState('reading_1') // Default active tab
  const { id } = useParams()

  // Function to parse query parameters from the URL
  const getQueryParam = (name) => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(name)
  }

  // Get student_id from URL query parameters
  let userId = getQueryParam('student_id')

  let downloadUrl = `/send-actreport/${id}`
  if (!userId) {
    userId = localStorage.getItem('userid')
  } else {
    downloadUrl = `/send-actreport/${id}?student_id=${userId}`
  }

  console.log('userId', userId)

  const handleTabClick = (tabId) => {
    setActiveTab(tabId)
  }
  const handlerTabClick = (tabId) => {
    rsetActiveTab(tabId)
  }

  const handleInnerTabClick = (index) => {
    setInnerActiveTab(index)
  }
  const [test_code, setTestCode] = useState([])
  const [test_date, setTestDate] = useState([])
  const [std_code, setstdCode] = useState([])
  const [english_correct, setecorrect] = useState([])
  const [english_wrong, setewrong] = useState([])
  const [english_omitted, seteomitted] = useState([])
  const [math_correct, setmcorrect] = useState([])
  const [math_wrong, setmwrong] = useState([])
  const [math_omitted, setmomitted] = useState([])
  const [reading_correct, setrcorrect] = useState([])
  const [reading_wrong, setrwrong] = useState([])
  const [reading_omitted, setromitted] = useState([])
  const [science_correct, setscorrect] = useState([])
  const [science_wrong, setswrong] = useState([])
  const [science_omitted, setsomitted] = useState([])
  const [total_correct, settcorrect] = useState([])
  const [total_wrong, settwrong] = useState([])
  const [total_omitted, settomitted] = useState([])
  const [total_esscore, settotal_esscore] = useState([])
  const [total_msscore, settotal_msscore] = useState([])
  const [total_rsscore, settotal_rsscore] = useState([])
  const [total_ssscore, settotal_ssscore] = useState([])
  const [total_scalecore, settotal_scalescore] = useState([])

  const chartData = {
    labels: ['English', 'Math', 'Reading', 'Science'],
    datasets: [
      {
        label: 'Scores',
        backgroundColor: ['#3a2f7c', '#3a2f7c', '#ed197e', '#ed197e'],
        borderColor: ['#3a2f7c', '#3a2f7c', '#ed197e', '#ed197e'],
        borderWidth: 1,
        maxBarThickness: 6,

        data: [
          english_correct,
          math_correct,
          reading_correct,
          science_correct,
          36,
        ],
      },
    ],
  }
  const getsweekness = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getactweekness/${id}/${userId}?section=1`
    )
    if (response.status === 200) {
      setResults(response.data)
    }
  }
  const getsweekness2 = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getactweekness/${id}/${userId}?section=2`
    )
    if (response.status === 200) {
      setResults2(response.data)
    }
  }
  const getsweekness3 = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getactweekness/${id}/${userId}?section=3`
    )
    if (response.status === 200) {
      setResults3(response.data)
    }
  }
  const getsweekness4 = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getactweekness/${id}/${userId}?section=4`
    )
    if (response.status === 200) {
      setResults4(response.data)
    }
  }

  const getReport = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}getactreportbyuser/${userId}/${id}`
      )
      if (response.status === 200) {
        setTestCode(response.data.test_code)
        setTestDate(response.data.test_date)
        setstdCode(response.data.std_code)
        setecorrect(response.data.english_correct)
        setewrong(response.data.english_wrong)
        seteomitted(response.data.english_omitted)
        setmcorrect(response.data.math_correct)
        setmwrong(response.data.math_wrong)
        setmomitted(response.data.math_omitted)
        setrcorrect(response.data.reading_correct)
        setrwrong(response.data.reading_wrong)
        setromitted(response.data.reading_omitted)
        setscorrect(response.data.science_correct)
        setswrong(response.data.science_wrong)
        setsomitted(response.data.science_omitted)
        settcorrect(response.data.total_correct)
        settwrong(response.data.total_wrong)
        settomitted(response.data.total_omitted)
        settotal_esscore(response.data.englishscaleScore)
        settotal_msscore(response.data.mathscaleScore)
        settotal_rsscore(response.data.readingscaleScore)
        settotal_ssscore(response.data.sciencecscaleScore)
        settotal_scalescore(response.data.totalscaleScore)
      }
    } catch (error) {
      console.error('Error fetching questions:', error)
    }
  }

  const gettests = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getacttest/${id}/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${userId}`,
        },
        useEffect,
      }
    )
    if (response.status === 200) {
      setData(response.data.data)
    }
  }

  const [selectedAnswers, setSelectedAnswers] = useState(
    data.reduce((acc, item) => {
      acc[item._id] = item.selectedAnswer || '' // Set initial value of selected answers
      return acc
    }, {})
  )

  // Handle change in the selected answer for a specific question

  // Handle change in the selected answer for a specific question
  const handleSelectChange = (id, value, citem) => {
    const currentStatus = value === citem

    // Update selectedAnswers state
    setSelectedAnswers((prevSelectedAnswers) => ({
      ...prevSelectedAnswers,
      [id]: {
        selectedAnswer: value,
        Answer: value,
        status: currentStatus, // Pass the status here as well
      },
    }))

    // Update data state
    setData((prevItems) =>
      prevItems.map((item) =>
        item._id === id ? { ...item, selectedAnswer: value } : item
      )
    )
  }

  const handleSaveAll = async (section_name) => {
    try {
      const updates = []
      // Define your additional fields
      const created_by = userId // Replace with the actual test ID
      const test_id = id // Replace with actual module type
      const section = section_name // Replace with actual section type

      // Loop through selectedAnswers and prepare the updates array
      for (const [id, { selectedAnswer, status, Answer }] of Object.entries(
        selectedAnswers
      )) {
        const update = {
          id: id,
          selected_answer: selectedAnswer,
          Answer: Answer, // Use selectedAnswer from selectedAnswers
          status: status, // Use status from selectedAnswers
        }

        updates.push(update) // Push each updated answer into the updates array
      }

      // Only send the updates if there are changes
      if (updates.length > 0) {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}updateactstatus`,
          {
            created_by: created_by,
            section: section,
            test_id: test_id,
            questions_and_answers: updates,
          },
          {
            headers: {
              'content-type': 'application/json',
              token: localStorage.getItem('token'),
            },
          }
        )

        // Check if the response status is success
        if (response.status === 200) {
          alert('Success! All answers have been saved for this module.')
          window.location.reload(true)
        }
      } else {
        alert('No changes detected')
      }

      // Only send the updates if there are changes
    } catch (error) {
      console.error('Error saving answers:', error)
    }
  }

  const Loader = ({ subject, score, range, delta, color }) => {
    return (
      <div className="summary-loader">
        <div className="loader">
          <div className="loader-rings-container">
            {/* SVG Loader */}
            <svg
              className="loader-rings"
              style={{ width: '200px', height: '200px', stroke: color }}
            >
              <circle
                className="loader-ring"
                r="96"
                cx="100"
                cy="100"
                strokeDashoffset="603.1857894892403"
                style={{
                  strokeDasharray: '603.186, 603.186',
                  strokeDashoffset: '15.0796',
                }}
              ></circle>
              <circle
                className="loader-ring"
                stroke="#dadada"
                strokeOpacity="0.3"
                r="96"
                cx="100"
                cy="100"
              ></circle>
            </svg>
            {/* Loader Text */}
            <div className="loader-text-container big">
              <div className="loader-text">{subject}</div>
              <div className="loader-score">{score}</div>
              <div className="loader-text">{range}</div>
              <div className="delta">{delta}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Prepare data for new components
  const scores = {
    English: total_esscore,
    Math: total_msscore,
    Reading: total_rsscore,
    Science: total_ssscore,
    Total: total_scalecore,
  }

  const detailedScores = {
    English: {
      correct: english_correct,
      incorrect: english_wrong,
      omitted: english_omitted,
      scaleScore: total_esscore,
    },
    Math: {
      correct: math_correct,
      incorrect: math_wrong,
      omitted: math_omitted,
      scaleScore: total_msscore,
    },
    Reading: {
      correct: reading_correct,
      incorrect: reading_wrong,
      omitted: reading_omitted,
      scaleScore: total_rsscore,
    },
    Science: {
      correct: science_correct,
      incorrect: science_wrong,
      omitted: science_omitted,
      scaleScore: total_ssscore,
    },
    Total: {
      correct: total_correct,
      incorrect: total_wrong,
      omitted: total_omitted,
      scaleScore: total_scalecore,
    },
  }

  const accuracyData = {
    English: `${((english_correct / 75) * 100).toFixed(2)}%`,
    Math: `${((math_correct / 60) * 100).toFixed(2)}%`,
    Reading: `${((reading_correct / 40) * 100).toFixed(2)}%`,
    Science: `${((science_correct / 40) * 100).toFixed(2)}%`,
  }

  // Add a simple download icon SVG inline
  const DownloadIcon = ({ className }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
    >
      <path
        d="M5.43652 6.81323L6.92986 8.30657L8.42319 6.81323"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.93018 2.33325V8.26575"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6668 7.10498C11.6668 9.68331 9.91683 11.7716 7.00016 11.7716C4.0835 11.7716 2.3335 9.68331 2.3335 7.10498"
        stroke="white"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  return (
    <div
      className="main-content-wrapper"
      style={{ width: '100%', margin: '40px 0 0 0', padding: '24px 0' }}
    >
      <div className="flex justify-between items-center mb-4 mt-2 px-8">
        <h1 className="text-xl font-bold text-[#030303]">
          ACT One - Score Details
        </h1>
        <a
          className="flex items-center gap-2 justify-center bg-[#DE3C7D] text-white px-3 py-2.5 rounded-md text-base font-semibold shadow-none hover:bg-[#c72c6a] transition-colors duration-200"
          href={downloadUrl}
          style={{
            minWidth: 120,
            textAlign: 'center',
            textDecoration: 'none',
          }}
        >
          <span>Download Report</span>
          <DownloadIcon className="w-4 h-4 text-white" />
        </a>
      </div>
      <div
        className="middle_container px-8"
        style={{ width: '100%', maxWidth: '100%', margin: 0, padding: 0 }}
      >
        <div
          className="page-content"
          style={{ width: '100%', maxWidth: '100%', margin: 0, padding: 0 }}
        >
          <div className="tabbed" style={{ width: '100%', maxWidth: '100%' }}>
            <ScoreTabs activeTab={activeTab} onTabChange={handleTabClick} />
            <div className="tab-content" style={{ width: '100%' }}>
              {activeTab === 'score-view' && (
                <>
                  <ScoreCards scores={scores} />
                  <div className="mb-8" />
                  <div className="flex items-center gap-2 mb-4">
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M7.93555 9.86368C7.79242 9.87702 7.64874 9.84472 7.52509 9.77139C7.48049 9.72561 7.44676 9.67038 7.42638 9.6098C7.40601 9.54921 7.39951 9.48482 7.40738 9.42139C7.41071 9.31442 7.42349 9.20795 7.44555 9.10322C7.46691 8.98307 7.4945 8.86413 7.52827 8.74685L7.90372 7.45502C7.94245 7.32751 7.96804 7.19637 7.98009 7.06365C7.98009 6.92048 7.99918 6.82182 7.99918 6.76456C8.00312 6.63859 7.97856 6.51335 7.92732 6.3982C7.87608 6.28305 7.79949 6.18097 7.70327 6.09956C7.46349 5.91549 7.16489 5.825 6.86327 5.84502C6.64711 5.84827 6.43264 5.88366 6.22689 5.95002C6.00205 6.02002 5.76552 6.1038 5.51735 6.20139L5.40918 6.62139C5.48235 6.59593 5.57146 6.56731 5.67327 6.53548C5.77038 6.5067 5.87106 6.49171 5.97235 6.49093C6.11444 6.47553 6.25742 6.51044 6.37644 6.58956C6.41644 6.6373 6.44636 6.69263 6.46441 6.75224C6.48245 6.81185 6.48825 6.87449 6.48144 6.93639C6.48108 7.04339 6.46935 7.15005 6.44644 7.25456C6.42415 7.36594 6.39552 7.48365 6.36052 7.60774L5.98189 8.90591C5.95138 9.02657 5.92696 9.1487 5.90872 9.27182C5.89385 9.37723 5.88641 9.48354 5.88644 9.58999C5.88567 9.71678 5.91395 9.84206 5.9691 9.95623C6.02425 10.0704 6.10481 10.1704 6.20461 10.2486C6.44809 10.4356 6.75092 10.5282 7.05732 10.5095C7.27308 10.514 7.48809 10.4828 7.6937 10.4173C7.874 10.3557 8.11476 10.2677 8.41598 10.1532L8.51781 9.75225C8.43622 9.7861 8.35219 9.81375 8.26644 9.83497C8.15799 9.85972 8.04664 9.86938 7.93555 9.86368ZM8.33327 3.73868C8.1601 3.57964 7.93193 3.49408 7.69689 3.50005C7.46197 3.49475 7.23404 3.58022 7.06052 3.73868C6.74246 4.01293 6.70694 4.49312 6.98123 4.81121C7.00567 4.83956 7.03217 4.86606 7.06052 4.8905C7.42288 5.21461 7.97091 5.21461 8.33324 4.8905C8.6513 4.61354 8.68463 4.1312 8.40767 3.81313C8.38462 3.78662 8.35976 3.76174 8.33327 3.73868Z"
                          fill="#DE3C7D"
                        />
                        <path
                          d="M7 0C3.134 0 0 3.134 0 7C0 10.866 3.134 14 7 14C10.866 14 14 10.866 14 7C14 3.134 10.866 0 7 0ZM7 13.3636C3.48545 13.3636 0.636371 10.5145 0.636371 7C0.636371 3.48545 3.48545 0.636371 7 0.636371C10.5145 0.636371 13.3636 3.48545 13.3636 7C13.3636 10.5145 10.5145 13.3636 7 13.3636Z"
                          fill="#DE3C7D"
                        />
                      </svg>
                    </span>
                    <span className="text-[#DE3C7D] text-sm">
                      These practice tests, modeled after actual exams, are
                      designed for rigorous preparation. Scores are estimates,
                      not real SAT predictions, and may change as materials and
                      scoring are refined with additional data.
                    </span>
                  </div>
                  <ScoreTable detailedScores={detailedScores} />
                  <AccuracyChart accuracyData={accuracyData} />
                </>
              )}

              {activeTab === 'english' && (
                <>
                  {/* Stats Cards */}
                  <EnglishStatsCards
                    statsData={{
                      total: 75,
                      correct: english_correct,
                      incorrect: english_wrong,
                      omitted: english_omitted,
                    }}
                  />
                  {/* Section Title */}
                  <div className="text-xl font-bold text-[#222] mb-4">
                    English Overview
                  </div>
                  {/* Modern Table */}
                  <div className="overflow-x-auto bg-white rounded-xl border border-[#F0F0F0]">
                    <table className="min-w-full text-sm">
                      <thead>
                        <tr className="bg-[#F8F8F8] text-[#535862] font-semibold">
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Question
                          </th>
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Topic
                          </th>
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Sub Topic
                          </th>
                          <th className="py-3 px-4 text-center border-r border-[#F0F0F0]">
                            Correct Answer
                          </th>
                          <th className="py-3 px-4 text-center">Your Answer</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(data) &&
                          data
                            .filter((item) => item.section === 'English')
                            .map((item, index) => (
                              <tr
                                key={item._id || index}
                                className="border-t border-[#F0F0F0]"
                              >
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.question_number}
                                </td>
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.topic}
                                </td>
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.subtopic}
                                </td>
                                <td className="py-2 px-4 text-center border-r border-[#F0F0F0]">
                                  {item.answer}
                                </td>
                                <td className="py-2 px-4 text-center">
                                  {rolename === 'admin' ? (
                                    <div className="relative inline-block">
                                      <select
                                        onChange={(e) =>
                                          handleSelectChange(
                                            item._id,
                                            e.target.value,
                                            item.answer
                                          )
                                        }
                                        value={item.selectedAnswer}
                                        className="appearance-none px-3 py-1.5 bg-white border border-[#E5E7EB] rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:border-transparent transition-all duration-200 pr-8 w-[80px]"
                                        style={{
                                          color:
                                            item.selectedAnswer === item.answer
                                              ? '#3BBC4C'
                                              : '#E90004',
                                          cursor: 'pointer',
                                          WebkitAppearance: 'none',
                                          MozAppearance: 'none',
                                        }}
                                      >
                                        <option
                                          value=""
                                          className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                        >
                                          Select
                                        </option>
                                        {item.question_number % 2 === 0
                                          ? ['F', 'G', 'H', 'J', 'K'].map(
                                              (option) => (
                                                <option
                                                  key={option}
                                                  value={option}
                                                  className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                                >
                                                  {option}
                                                </option>
                                              )
                                            )
                                          : ['A', 'B', 'C', 'D', 'E'].map(
                                              (option) => (
                                                <option
                                                  key={option}
                                                  value={option}
                                                  className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                                >
                                                  {option}
                                                </option>
                                              )
                                            )}
                                      </select>
                                      <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
                                        <svg
                                          className="fill-current h-4 w-4 text-[#535862]"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                        >
                                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                        </svg>
                                      </div>
                                    </div>
                                  ) : (
                                    <span
                                      className={
                                        item.selectedAnswer === item.answer
                                          ? 'font-semibold text-[#3BBC4C]'
                                          : 'font-semibold text-[#E90004]'
                                      }
                                    >
                                      {item.selectedAnswer}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                      </tbody>
                    </table>
                  </div>
                  {rolename === 'admin' && (
                    <div className="mt-6 text-center">
                      <button
                        onClick={() => handleSaveAll('English')}
                        className="bg-[#DE3C7D] text-white px-6 py-2.5 rounded-md text-sm font-semibold hover:bg-[#c72c6a] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:ring-offset-2"
                      >
                        Save Changes
                      </button>
                    </div>
                  )}
                </>
              )}

              {activeTab === 'mathematics' && (
                <>
                  {/* Stats Cards for Math */}
                  <EnglishStatsCards
                    statsData={{
                      total: 60,
                      correct: math_correct,
                      incorrect: math_wrong,
                      omitted: math_omitted,
                    }}
                  />
                  {/* Section Title */}
                  <div className="text-xl font-bold text-[#222] mb-4">
                    Mathematics Overview
                  </div>
                  {/* Modern Table */}
                  <div className="overflow-x-auto bg-white rounded-xl border border-[#F0F0F0]">
                    <table className="min-w-full text-sm">
                      <thead>
                        <tr className="bg-[#F8F8F8] text-[#535862] font-semibold">
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Question
                          </th>
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Topic
                          </th>
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Sub Topic
                          </th>
                          <th className="py-3 px-4 text-center border-r border-[#F0F0F0]">
                            Correct Answer
                          </th>
                          <th className="py-3 px-4 text-center">Your Answer</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(data) &&
                          data
                            .filter((item) => item.section === 'Math')
                            .map((item, index) => (
                              <tr
                                key={item._id || index}
                                className="border-t border-[#F0F0F0]"
                              >
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.question_number}
                                </td>
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.topic}
                                </td>
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.subtopic}
                                </td>
                                <td className="py-2 px-4 text-center border-r border-[#F0F0F0]">
                                  {item.answer}
                                </td>
                                <td className="py-2 px-4 text-center">
                                  {rolename === 'admin' ? (
                                    <div className="relative inline-block">
                                      <select
                                        onChange={(e) =>
                                          handleSelectChange(
                                            item._id,
                                            e.target.value,
                                            item.answer
                                          )
                                        }
                                        value={item.selectedAnswer}
                                        className="appearance-none px-3 py-1.5 bg-white border border-[#E5E7EB] rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:border-transparent transition-all duration-200 pr-8 w-[80px]"
                                        style={{
                                          color:
                                            item.selectedAnswer === item.answer
                                              ? '#3BBC4C'
                                              : '#E90004',
                                          cursor: 'pointer',
                                          WebkitAppearance: 'none',
                                          MozAppearance: 'none',
                                        }}
                                      >
                                        <option
                                          value=""
                                          className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                        >
                                          Select
                                        </option>
                                        {item.question_number % 2 === 0
                                          ? ['F', 'G', 'H', 'J', 'K'].map(
                                              (option) => (
                                                <option
                                                  key={option}
                                                  value={option}
                                                  className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                                >
                                                  {option}
                                                </option>
                                              )
                                            )
                                          : ['A', 'B', 'C', 'D', 'E'].map(
                                              (option) => (
                                                <option
                                                  key={option}
                                                  value={option}
                                                  className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                                >
                                                  {option}
                                                </option>
                                              )
                                            )}
                                      </select>
                                      <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
                                        <svg
                                          className="fill-current h-4 w-4 text-[#535862]"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                        >
                                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                        </svg>
                                      </div>
                                    </div>
                                  ) : (
                                    <span
                                      className={
                                        item.selectedAnswer === item.answer
                                          ? 'font-semibold text-[#3BBC4C]'
                                          : 'font-semibold text-[#E90004]'
                                      }
                                    >
                                      {item.selectedAnswer}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                      </tbody>
                    </table>
                  </div>
                  {rolename === 'admin' && (
                    <div className="mt-6 text-center">
                      <button
                        onClick={() => handleSaveAll('Math')}
                        className="bg-[#DE3C7D] text-white px-6 py-2.5 rounded-md text-sm font-semibold hover:bg-[#c72c6a] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:ring-offset-2"
                      >
                        Save Changes
                      </button>
                    </div>
                  )}
                </>
              )}
              {activeTab === 'reading' && (
                <>
                  <EnglishStatsCards
                    statsData={{
                      total: 40,
                      correct: reading_correct,
                      incorrect: reading_wrong,
                      omitted: reading_omitted,
                    }}
                  />
                  <div className="text-xl font-bold text-[#222] mb-4">
                    Reading Overview
                  </div>
                  <div className="overflow-x-auto bg-white rounded-xl border border-[#F0F0F0]">
                    <table className="min-w-full text-sm">
                      <thead>
                        <tr className="bg-[#F8F8F8] text-[#535862] font-semibold">
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Question
                          </th>
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Topic
                          </th>
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Sub Topic
                          </th>
                          <th className="py-3 px-4 text-center border-r border-[#F0F0F0]">
                            Correct Answer
                          </th>
                          <th className="py-3 px-4 text-center">Your Answer</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(data) &&
                          data
                            .filter((item) => item.section === 'Reading')
                            .map((item, index) => (
                              <tr
                                key={item._id || index}
                                className="border-t border-[#F0F0F0]"
                              >
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.question_number}
                                </td>
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.topic}
                                </td>
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.subtopic}
                                </td>
                                <td className="py-2 px-4 text-center border-r border-[#F0F0F0]">
                                  {item.answer}
                                </td>
                                <td className="py-2 px-4 text-center">
                                  {rolename === 'admin' ? (
                                    <div className="relative inline-block">
                                      <select
                                        onChange={(e) =>
                                          handleSelectChange(
                                            item._id,
                                            e.target.value,
                                            item.answer
                                          )
                                        }
                                        value={item.selectedAnswer}
                                        className="appearance-none px-3 py-1.5 bg-white border border-[#E5E7EB] rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:border-transparent transition-all duration-200 pr-8 w-[80px]"
                                        style={{
                                          color:
                                            item.selectedAnswer === item.answer
                                              ? '#3BBC4C'
                                              : '#E90004',
                                          cursor: 'pointer',
                                          WebkitAppearance: 'none',
                                          MozAppearance: 'none',
                                        }}
                                      >
                                        <option
                                          value=""
                                          className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                        >
                                          Select
                                        </option>
                                        {item.question_number % 2 === 0
                                          ? ['F', 'G', 'H', 'J'].map(
                                              (option) => (
                                                <option
                                                  key={option}
                                                  value={option}
                                                  className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                                >
                                                  {option}
                                                </option>
                                              )
                                            )
                                          : ['A', 'B', 'C', 'D'].map(
                                              (option) => (
                                                <option
                                                  key={option}
                                                  value={option}
                                                  className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                                >
                                                  {option}
                                                </option>
                                              )
                                            )}
                                      </select>
                                      <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
                                        <svg
                                          className="fill-current h-4 w-4 text-[#535862]"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                        >
                                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                        </svg>
                                      </div>
                                    </div>
                                  ) : (
                                    <span
                                      className={
                                        item.selectedAnswer === item.answer
                                          ? 'font-semibold text-[#3BBC4C]'
                                          : 'font-semibold text-[#E90004]'
                                      }
                                    >
                                      {item.selectedAnswer}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                      </tbody>
                    </table>
                  </div>
                  {rolename === 'admin' && (
                    <div className="mt-6 text-center">
                      <button
                        onClick={() => handleSaveAll('Reading')}
                        className="bg-[#DE3C7D] text-white px-6 py-2.5 rounded-md text-sm font-semibold hover:bg-[#c72c6a] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:ring-offset-2"
                      >
                        Save Changes
                      </button>
                    </div>
                  )}
                </>
              )}
              {activeTab === 'science' && (
                <>
                  <EnglishStatsCards
                    statsData={{
                      total: 40,
                      correct: science_correct,
                      incorrect: science_wrong,
                      omitted: science_omitted,
                    }}
                  />
                  <div className="text-xl font-bold text-[#222] mb-4">
                    Science Overview
                  </div>
                  <div className="overflow-x-auto bg-white rounded-xl border border-[#F0F0F0]">
                    <table className="min-w-full text-sm">
                      <thead>
                        <tr className="bg-[#F8F8F8] text-[#535862] font-semibold">
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Question
                          </th>
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Topic
                          </th>
                          <th className="py-3 px-4 text-left border-r border-[#F0F0F0]">
                            Sub Topic
                          </th>
                          <th className="py-3 px-4 text-center border-r border-[#F0F0F0]">
                            Correct Answer
                          </th>
                          <th className="py-3 px-4 text-center">Your Answer</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(data) &&
                          data
                            .filter((item) => item.section === 'Science')
                            .map((item, index) => (
                              <tr
                                key={item._id || index}
                                className="border-t border-[#F0F0F0]"
                              >
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.question_number}
                                </td>
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.topic}
                                </td>
                                <td className="py-2 px-4 text-left border-r border-[#F0F0F0]">
                                  {item.subtopic}
                                </td>
                                <td className="py-2 px-4 text-center border-r border-[#F0F0F0]">
                                  {item.answer}
                                </td>
                                <td className="py-2 px-4 text-center">
                                  {rolename === 'admin' ? (
                                    <div className="relative inline-block">
                                      <select
                                        onChange={(e) =>
                                          handleSelectChange(
                                            item._id,
                                            e.target.value,
                                            item.answer
                                          )
                                        }
                                        value={item.selectedAnswer}
                                        className="appearance-none px-3 py-1.5 bg-white border border-[#E5E7EB] rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:border-transparent transition-all duration-200 pr-8 w-[80px]"
                                        style={{
                                          color:
                                            item.selectedAnswer === item.answer
                                              ? '#3BBC4C'
                                              : '#E90004',
                                          cursor: 'pointer',
                                          WebkitAppearance: 'none',
                                          MozAppearance: 'none',
                                        }}
                                      >
                                        <option
                                          value=""
                                          className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                        >
                                          Select
                                        </option>
                                        {item.question_number % 2 === 0
                                          ? ['F', 'G', 'H', 'J'].map(
                                              (option) => (
                                                <option
                                                  key={option}
                                                  value={option}
                                                  className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                                >
                                                  {option}
                                                </option>
                                              )
                                            )
                                          : ['A', 'B', 'C', 'D'].map(
                                              (option) => (
                                                <option
                                                  key={option}
                                                  value={option}
                                                  className="text-[#535862] bg-white hover:bg-[#F8F8F8]"
                                                >
                                                  {option}
                                                </option>
                                              )
                                            )}
                                      </select>
                                      <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
                                        <svg
                                          className="fill-current h-4 w-4 text-[#535862]"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 20 20"
                                        >
                                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                        </svg>
                                      </div>
                                    </div>
                                  ) : (
                                    <span
                                      className={
                                        item.selectedAnswer === item.answer
                                          ? 'font-semibold text-[#3BBC4C]'
                                          : 'font-semibold text-[#E90004]'
                                      }
                                    >
                                      {item.selectedAnswer}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                      </tbody>
                    </table>
                  </div>
                  {rolename === 'admin' && (
                    <div className="mt-6 text-center">
                      <button
                        onClick={() => handleSaveAll('Science')}
                        className="bg-[#DE3C7D] text-white px-6 py-2.5 rounded-md text-sm font-semibold hover:bg-[#c72c6a] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#DE3C7D] focus:ring-offset-2"
                      >
                        Save Changes
                      </button>
                    </div>
                  )}
                </>
              )}
              {activeTab === 'strength-weakness' && (
                <StrengthsWeaknesses
                  results={results}
                  results2={results2}
                  results3={results3}
                  results4={results4}
                  testType="ACT"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
const cellStyle = {
  border: '1px solid #000',
  padding: '8px',
  textAlign: 'center',
}

const labelStyle = {
  display: 'block',
  margin: '4px 0',
}
export default ActScores
